import { createFileRoute } from '@tanstack/react-router';

import { OrganizationPage } from '@/features/members/pages/OrganizationPage';

export const Route = createFileRoute('/_authenticated/organization')({
  component: OrganizationPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Organization', href: '/organization' }],
  }),
});
